import { CadastroAplicativoInicial } from "../models/cadastroAplicativoModel"
import type { CadastroAplicativoModel } from "../models/cadastroAplicativoModel"
import { CadastroAplicativoActionsTypes } from "./cadastroAplicativoActions"
import type { CadastroAplicativoActionModel } from "./cadastroAplicativoActions"

export function cadastroAplicativoReducer(
    state: CadastroAplicativoModel,
    action: CadastroAplicativoActionModel
): CadastroAplicativoModel {
    switch (action.type) {
        case CadastroAplicativoActionsTypes.CARREGAR:
            return action.payload

        case CadastroAplicativoActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case CadastroAplicativoActionsTypes.CARREGAR_PROMOCOES:
            return {
                ...state,
                promocoes: action.payload,
                idPromocaoPrincipal: null,
            }

        default:
            return state
    }
}

export { CadastroAplicativoInicial }
